var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCrossRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    width: 24,
    height: 24,
    "data-name": "Layer 2",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close",
    fill: "#d93829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7282",
    d: "M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 1 0 1.42 1.42l4.29-4.3 4.29 4.3a1 1 0 1 0 1.42-1.42z",
    "data-name": "Path 7282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCrossRed);
export default __webpack_public_path__ + "static/media/icon-cross--red.129915a11ffc8bbbe4b91a04b8f1b518.svg";
export { ForwardRef as ReactComponent };